import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Building2, TrendingUp, Briefcase, Target, FileCheck, Handshake } from 'lucide-react';

const iconMap = {
  Building2,
  TrendingUp,
  Briefcase,
  Target,
  FileCheck,
  Handshake,
};

const ServicesSection = () => {
  const { t } = useLanguage();

  return (
    <section id="services" className="relative py-24 bg-white overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-amber-100/50 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-blue-100/50 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 rounded-full bg-amber-100 text-amber-700 text-sm font-medium mb-4">
            {t.services.sectionTag}
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            {t.services.title}
          </h2>
          <p className="max-w-2xl mx-auto text-lg text-slate-600">
            {t.services.subtitle}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.services.items.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative p-8 bg-white rounded-2xl border border-slate-200 hover:border-amber-300 shadow-sm hover:shadow-xl transition-all duration-500 hover:-translate-y-2"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-amber-100 to-amber-50 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500">
                  {IconComponent && (
                    <IconComponent className="w-7 h-7 text-amber-600" />
                  )}
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-amber-600 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {service.description}
                </p>

                {/* Hover Accent */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-amber-400 to-amber-600 rounded-b-2xl transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
